var map = {
	"./ar.json": "6237",
	"./de.json": "c112",
	"./en.json": "5848",
	"./es.json": "dc65",
	"./fr.json": "3b1bd",
	"./he.json": "a94e",
	"./hi.json": "b8d5",
	"./id.json": "9717",
	"./ja.json": "3533",
	"./ko.json": "96e0",
	"./nl.json": "1180",
	"./pt.json": "3854",
	"./ru.json": "cfbde",
	"./tr.json": "7ff6",
	"./vi.json": "03e5",
	"./zh.json": "4f54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8c1";